import { faPlayCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

import { LandingPageProps } from '..';

type Props = {
  lpProps: LandingPageProps;
  isDiscounted: boolean | null;
  onButtonClick: () => void;
};

const Component: React.FC<Props> = ({
  lpProps,
  isDiscounted,
  onButtonClick,
}) => {
  return (
    <div className="mb-9 mt-5 flex w-full flex-col items-center bg-[#FFB09A] py-4">
      <div className="flex items-center">
        <div className="z-20 flex flex-col font-bold text-[#202956]">
          <div className="flex items-baseline">
            <div className="text-2xl">{lpProps.totalVideos}本</div>
            <div>以上の</div>
          </div>
          <div className="flex items-baseline">
            <div className="text-2xl">レッスン動画</div>
            <div>を</div>
            <div className="text-2xl">見放題</div>
          </div>
        </div>
        {isDiscounted === null ? (
          <div className="h-[100px] w-[108px]" />
        ) : (
          <div className="relative flex">
            <div
              className={classnames(
                'absolute right-[45px] z-10 flex w-28 flex-col rounded-sm bg-white/90 p-[2px] font-bold text-[#202956]',
                isDiscounted ? 'block' : 'hidden',
              )}
            >
              <div className="ml-6 text-[8px]">今だけ初月</div>
              <div className="ml-1 flex items-center">
                <div className="text-xs">¥{lpProps.discountedPriceWithTax}</div>
                <div className="text-[8px]">(税込)</div>
              </div>
            </div>
            <div className="z-20 mb-3 ml-5 flex h-[88px] w-[88px] flex-col items-center justify-center rounded-full bg-white pb-2 font-bold text-[#EC5931]">
              <div className="text-[10px]">月額</div>
              <div className="relative flex flex-col items-center justify-center">
                <div
                  className={classnames(
                    'absolute z-30 h-[10px] w-[95px] border-y-[3px] border-solid border-[#202956]',
                    isDiscounted ? 'block' : 'hidden',
                  )}
                />
                <div>¥{lpProps.price}</div>
              </div>
              <div className="text-[10px]">（税込¥{lpProps.priceWithTax}）</div>
            </div>
          </div>
        )}
      </div>

      <a
        onClick={onButtonClick}
        className="flex h-20 w-72 cursor-pointer items-center justify-center rounded-sm border-[3px] border-solid border-[#EC5931] bg-white font-bold text-[#EC5931] hover:bg-white/80"
      >
        <FontAwesomeIcon className="text-2xl" icon={faPlayCircle} />
        <div className="ml-2">会員登録で動画を見る</div>
      </a>
    </div>
  );
};

export default Component;
